import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  useGetMediaByDetailsQuery,
  useGetMediaTypesQuery,
} from "../../actions/surveyActions";

const MEDIA_TYPE_IDS = {
  audio: 1,
  photo: 2,
  video: 3,
};

const Requests = ({ pendingRequests }) => {
  const [toggleRequestTabs, setToggleRequestTabs] = useState(1);
  const [completed, setCompleted] = useState(0);

  const { data: allRequests, isLoading: allLoading } =
    useGetMediaByDetailsQuery({ interactType: 1 });

  const { data: photoRequests, isLoading: photoLoading } =
    useGetMediaByDetailsQuery({
      mediaType: MEDIA_TYPE_IDS.photo,
      interactType: 1,
    });

  const { data: videoRequests, isLoading: videoLoading } =
    useGetMediaByDetailsQuery({
      mediaType: MEDIA_TYPE_IDS.video,
      interactType: 1,
    });

  const { data: audioRequests, isLoading: audioLoading } =
    useGetMediaByDetailsQuery({
      mediaType: MEDIA_TYPE_IDS.audio,
      interactType: 1,
    });

  const { data: mediaTypesResponse } = useGetMediaTypesQuery();

  const mediaTypeNames = useMemo(() => {
    return (mediaTypesResponse?.data || []).reduce((lookup, mediaType) => {
      lookup[mediaType.id] = mediaType.value;
      return lookup;
    }, {});
  }, [mediaTypesResponse]);

  const getMediaTypeName = (mediaTypeId) =>
    mediaTypeNames[mediaTypeId] || "Media";

  useEffect(() => {
    const responses = pendingRequests?.responses || [];
    const finishedResponses = responses.filter(
      (response) =>
        response.status === "approved" || response.status === "rejected"
    );

    console.log("responses", responses);

    setCompleted(finishedResponses.length);
  }, [pendingRequests]);

  const getRequestsForTab = () => {
    if (toggleRequestTabs === 2) {
      return photoRequests?.requests || [];
    }

    if (toggleRequestTabs === 3) {
      return videoRequests?.requests || [];
    }

    if (toggleRequestTabs === 4) {
      return audioRequests?.requests || [];
    }

    return allRequests?.requests || [];
  };

  const isLoading =
    toggleRequestTabs === 1
      ? allLoading
      : toggleRequestTabs === 2
      ? photoLoading
      : toggleRequestTabs === 3
      ? videoLoading
      : audioLoading;

  const requests = getRequestsForTab();

  const renderMediaIcon = (mediaType) => {
    if (mediaType === MEDIA_TYPE_IDS.video) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-video icon text-color-3 margin-right-1"
          aria-label="Video"
        >
          <polygon points="23 7 16 12 23 17 23 7" />
          <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
        </svg>
      );
    }

    if (mediaType === MEDIA_TYPE_IDS.photo) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-camera icon text-color-3 margin-right-1"
          aria-label="Photo"
        >
          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
          <circle cx="12" cy="13" r="4" />
        </svg>
      );
    }

    if (mediaType === MEDIA_TYPE_IDS.audio) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-mic icon text-color-3 margin-right-1"
          aria-label="Audio"
        >
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
          <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
          <line x1="12" y1="19" x2="12" y2="23" />
          <line x1="8" y1="23" x2="16" y2="23" />
        </svg>
      );
    }

    return null;
  };

  const renderRequest = (request) => (
    <div
      key={request.mmCampaignRef}
      className="radius-large background-color-white box-shadow-large padding-6 border-1px flex-column flex-space-between"
    >
      <h4 className="margin-0">{request.clientName}</h4>
      <p className="margin-top-2">{request.name}</p>

      <div className="flex-align-center margin-top-6 flex-space-between portrait-flex-column portrait-flex-align-start">
        <div className="flex-align-center">
          <div className="flex-align-center margin-right-4">
            {renderMediaIcon(request.mediaType)}
            <span>{getMediaTypeName(request.mediaType)}</span>
          </div>
        </div>

        <Link
          className="button button-small portrait-margin-top-4 w-button"
          to={{
            pathname: "/requestStart",
            state: { request },
          }}
        >
          Start
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-arrow-right icon margin-left-1"
            aria-hidden="true"
          >
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </Link>
      </div>
    </div>
  );

  return (
    <div>
      <div className="grid-3-columns">
        <div id="w-node-_050d8f6d-c27f-b44d-0d25-58000ceda8cc-464ea933">
          <div className="flex-space-between">
            <h5 className="text-color-4 text-medium">Available requests</h5>
            <p className="text-color-2">{completed} Completed</p>
          </div>

          <div className="w-tabs">
            <div className="page-tabs _2 w-tab-menu" role="tablist">
              {[
                { id: 1, label: "All" },
                { id: 2, label: "Photo" },
                { id: 3, label: "Video" },
                { id: 4, label: "Audio" },
              ].map((tab) => (
                <a
                  key={tab.id}
                  className={
                    toggleRequestTabs === tab.id
                      ? "tab _2 w-inline-block w-tab-link w--current"
                      : "tab _2 w-inline-block w-tab-link"
                  }
                  href="#!"
                  onClick={(event) => {
                    event.preventDefault();
                    setToggleRequestTabs(tab.id);
                  }}
                  role="tab"
                  aria-selected={toggleRequestTabs === tab.id}
                >
                  <div>{tab.label}</div>
                </a>
              ))}
            </div>

            <div className="tabs-content w-tab-content">
              <div className="w-tab-pane w--tab-active">
                {isLoading ? (
                  <p>Loading requests...</p>
                ) : requests.length === 0 ? (
                  <p>No available requests.</p>
                ) : (
                  <div className="grid-2-columns">
                    {requests.map(renderRequest)}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div id="w-node-_99b8939e-d09a-891d-5c40-2d4fc1fecf0b-464ea933">
          <div className="flex-space-between">
            <h5 className="text-color-4 text-medium portrait-text-color-headings">
              Your Responses
            </h5>
            <p className="text-color-2">
              {pendingRequests?.responses?.filter(
                (response) => response.status === "pending"
              ).length || 0}{" "}
              Pending
            </p>
          </div>

          {pendingRequests?.responses?.map((response) => (
            <div
              key={response.responseRef}
              className="background-color-1 radius-large flex-column"
            >
              <Link
                className="w-inline-block"
                to={{
                  pathname:
                    response.status === "pending"
                      ? "/pendingResponse"
                      : response.status === "rejected"
                      ? "/rejectedResponse"
                      : response.status === "approved"
                      ? "/approvedResponse"
                      : "/dashboard",
                  state: { x: response },
                }}
              >
                <div className="padding-6 border-bottom-1px">
                  <div className="flex-space-between">
                    <div>
                      <h5 className="margin-0 margin-right-4">
                        {response.requestName}
                      </h5>
                      <p className="text-color-2 margin-bottom-0 margin-top-2">
                        Submitted{" "}
                        {new Intl.DateTimeFormat("en-GB", {
                          month: "long",
                          day: "2-digit",
                          year: "numeric",
                        }).format(new Date(response.createdAt))}
                      </p>
                    </div>
                    {response.status}
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Requests;
